/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getCompleteRotation__anchor
 */
export default pageNumber => window.documentViewer.getCompleteRotation(pageNumber);